const prefix = "#!/";

export function rootPath() {
  return prefix;
}

export function yearPath(year: number) {
  return `${prefix}year/${year}`;
}

export function dayPath(year: number, day: number) {
  return `${prefix}year/${year}/12/${day}`;
}
